<template>
  <v-container grid-list-lg>
    <v-layout wrap>
      <v-flex xs12>
        <v-btn
          class="mr-4"
          small
          text
          color="primary"
          :to="`/tools/manage/orders/${$route.params.orderNumber}`"
          ><v-icon small class="mr-2">chevron_left</v-icon> Back to Order</v-btn
        >
      </v-flex>
      <v-flex xs12>
        <tool-order-details
          v-if="toolOrder"
          :toolOrder="toolOrder"
          :incomplete="incomplete"
        />
      </v-flex>

      <v-flex xs12>
        <v-card v-if="toolOrder">
          <v-simple-table>
            <thead>
              <tr>
                <th class="text-left" width="100"></th>
                <th class="text-left" width="200">Name</th>
                <th class="text-left" width="80">QTY</th>
                <th class="text-left" width="80">Packed</th>
                <th class="text-left">Notes</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="tool in toolOrder.tools" :key="tool.id">
                <td class="py-4">
                  <img :src="tool.image" width="50" height="50" contain />
                </td>
                <td>
                  {{ tool.title }}
                </td>
                <td>
                  {{ tool.qty }}
                </td>
                <td>
                  <v-text-field readonly></v-text-field>
                </td>
                <td>
                  <v-text-field readonly></v-text-field>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import fb from "@/main";
import { sumBy } from "lodash";
import ToolOrderDetails from "@/components/toolOrders/ToolOrderDetails";
export default {
  components: { ToolOrderDetails },
  data() {
    return {
      toolOrder: null,
    };
  },
  async created() {
    try {
      const toolOrder = await fb.db
        .collection("toolOrders")
        .doc(this.$route.params.orderNumber)
        .get();
      this.toolOrder = toolOrder.data();
    } catch (error) {
      alert("Error getting orders.");
      console.log(error);
    }
  },
  methods: {
    fulfilledAmount(tool) {
      if (tool.fulfillments && !tool.fulfillments.length) {
        return tool.qtyFulfilled || 0;
      } else {
        return sumBy(tool.fulfillments, "qty");
      }
    },
    incomplete() {
      // cycle through all and determine if all items are fulfilled
      const found = this.toolOrder.tools.find((t) => {
        if (!t.cancelled) {
          return this.fulfilledAmount(t) < t.qty;
        }
      });
      return !!found;
    },
  },
};
</script>

<style>
.order-details-label {
  width: 80px;
}
@media print {
  header.v-sheet.v-sheet--tile.theme--light.v-toolbar.v-app-bar.v-app-bar--clipped.v-app-bar--fixed.secondary {
    display: none;
  }
  main.v-main {
    padding: 0 !important;
  }
  .v-toolbar__content {
    display: none !important;
  }
  nav.v-navigation-drawer.v-navigation-drawer--clipped.v-navigation-drawer--fixed.v-navigation-drawer--open.theme--light {
    display: none !important;
  }
}
</style>
